// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { passwordRequirementsValidatorStyles } from "@guestsupply/App/Components/Common/PasswordRequirements";
import color, { getSystemColor } from "@guestsupply/XDL/Utilities/color";
import { css } from "styled-components";

passwordRequirementsValidatorStyles.wrapper = {
    css: css`
        margin-bottom: 20px;
    `,
};

passwordRequirementsValidatorStyles.passwordRequirement = {
    css: css`
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 5px;
        color: ${({ passedRequirement, hasTyped }: any) =>
            !hasTyped ? color("common.ui6") : passedRequirement ? color("success") : color("danger")};
        display: flex;
        align-items: baseline;
        .icon {
            width: 12px;
            height: 12px;
            min-width: 12px;
            min-height: 12px;
            border: ${({ hasTyped }: any) => (hasTyped ? "0" : `1px solid ${getSystemColor("common.ui6")}`)};
            border-radius: 50%;
            margin-right: 7px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,
};
